import config from 'constants/config'
import { ANYWHERE_NAME } from 'constants/search'
import { useAppSelector } from 'hooks/reduxHooks'
import { useResponsive } from 'hooks/useResponsive'
import { parseSearchString } from 'lib/urlUtils'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { getNewHotelSearchPageAUExperimentVariant, getNewHotelSearchPageNonAUExperimentVariant } from 'selectors/searchSelectors'

export default function useShowNewHotelSearch() {
  const location = useLocation()
  const configEnabled = config.ENABLE_HOTEL_SEARCH_PAGE_FILTER_PANE
  const [match] = useResponsive()
  const isDesktop = !!(match?.md || match?.lg || match?.xl)
  const windowSearch = location.search
  const isMap = location.pathname.endsWith('/map')
  const params = useMemo(() => parseSearchString(windowSearch), [windowSearch])
  const isPropertySearch = !!params.propertyId
  const insideAUExperiment = useAppSelector(state => getNewHotelSearchPageAUExperimentVariant(state))
  const outsideAUExperiment = useAppSelector(state => getNewHotelSearchPageNonAUExperimentVariant(state))
  const searchTargetLabel = params.destinationName
  const isAnywhereSearch = searchTargetLabel === ANYWHERE_NAME

  return configEnabled && isDesktop && !isMap && !isPropertySearch && (insideAUExperiment || outsideAUExperiment) && !isAnywhereSearch
}
